import { Pagination, Select } from 'antd';
import gameApi from 'api/gameApi';
import {
  gameScoreMockMoreSportsCategory,
  gameScoreMockSportCategory,
  mockMoreSportsCategory,
  mockSportCategory,
  sportList,
} from 'api/mockSportCategory';
import { useAppTranslation } from 'app/hooks';
import EmptyTableIcon from 'assets/icons/EmptyTableIcon';
import { GameResponseModel } from 'models';
import React, { useEffect, useState } from 'react';
import { IMG_ALT } from 'consts/app';
import GameScore from './GameScore';
interface ResultChatProps {
  className?: string;
}
const { Option } = Select;
const ResultChat: React.FunctionComponent<ResultChatProps> = ({ className = '' }) => {
  const t = useAppTranslation();
  const [games, setGames] = useState<GameResponseModel[]>([]);
  const [currentSport, setCurrentSport] = useState<string>(sportList[0].lable);
  const [tabList, setTabList] = useState<{ value: string; label: string }[]>([]);
  const [selectedSportTitle, setSelectedSportTitle] = useState<string>();
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalGamesScore, setTotalGamesScore] = useState<number>(0);

  const getFinalScore = async () => {
    const { ok, body, pagination } = await gameApi.getGamesScore({
      page: currentPage,
      size: 10,
      sort: 'startDate,desc',
      'sportGroup.equals': currentSport,
      'sportTitle.equals': selectedSportTitle,
    });
    if (ok && body) {
      setGames(body);
      setTotalGamesScore(pagination?.total || 0);
    }
  };

  const handleChangeSport = (value: string) => {
    setCurrentSport(value);
  };

  const onChangeTab = (value: string) => {
    setSelectedSportTitle(value);
  };

  useEffect(() => {
    if (selectedSportTitle && currentSport) {
      getFinalScore();
    }
  }, [currentPage, selectedSportTitle]);

  useEffect(() => {
    setCurrentPage(0);
  }, [selectedSportTitle]);
  
  useEffect(() => {
    const categories = gameScoreMockSportCategory.filter(
      (c) => c.sportActivity.toLowerCase() === currentSport.toLowerCase(),
    );
    const moreSportCategories = gameScoreMockMoreSportsCategory.filter(
      (c) => c.sportActivity.toLowerCase() === currentSport.toLowerCase(),
    );
    const tab = categories.length
      ? categories
          .filter((item) => item.sportTitle !== 'Futures')
          .map((item) => ({
            value: item.sportTitle,
            label: item.sportTitleShort,
          }))
      : moreSportCategories.map((item) => ({
          value: item.sportTitle,
          label: item.sportTitleShort,
        }));
    setTabList(tab);
    if (tab.length > 0) {
      setSelectedSportTitle(tab[0].value);
    }
  }, [currentSport]);

  return (
    <div className={`chat-room__result ${className}`}>
      <div className="select-sport-league">
        <div className="select-game-score-board_container ">
          <Select
            className="select-game-score-board"
            dropdownClassName="score-board-item primary-text-color"
            defaultValue={currentSport}
            onChange={handleChangeSport}
            optionLabelProp="label"
          >
            {sportList.map((option) => (
              <Option
                key={option.key}
                value={option.lable}
                label={
                  <div className="flex-row items-center gap-1 p-1">
                    <img className="w-5 h-5" src={option.image} alt={IMG_ALT} />
                    <span className="primary-text-color">{t(option.title)}</span>
                  </div>
                }
              >
                <div className="flex-row items-center gap-1 p-1">
                  <img className="w-5 h-5" src={option.image} alt={IMG_ALT} />
                  <span className="primary-text-color">{t(option.title)}</span>
                </div>
              </Option>
            ))}
          </Select>
        </div>
        <div className="select-game-score-board_container">
          <Select
            className="select-game-score-board score-board"
            dropdownClassName="score-board-item score-board-width primary-text-color"
            onChange={onChangeTab}
            style={{ width: 'max-content' }}
            size="large"
            optionLabelProp="label"
            value={selectedSportTitle}
          >
            {tabList.map((option) => (
              <Option
                key={option.value}
                value={option.value}
                label={<p className=" select-tab-list-option">{t(option.label)}</p>}
              >
                <p className=" select-tab-list-option">{t(option.label)}</p>
              </Option>
            ))}
          </Select>
        </div>
      </div>

      {games.length > 0 ? games.map((item) => <GameScore game={item} />) : <EmptyTableIcon />}
      {games.length > 0 && (
        <div className="flex-row align-center justify-center mt-2  common-pagination">
          <Pagination
            current={currentPage + 1}
            total={totalGamesScore}
            onChange={(page) => setCurrentPage(page - 1)}
            pageSize={10}
            showSizeChanger={false}
            className="common-pagination"
          />
        </div>
      )}
    </div>
  );
};

export default ResultChat;
